import fire, { Shape } from 'canvas-confetti';

export async function confetti(sometimes = false) {
  return;

  if (sometimes && Math.random() < 0.2) {
    return;
  }

  const shapes: Array<Shape> = ['square', 'circle', fire.shapeFromText({ text: '🌈' })];

  fire({
    angle: 60,
    spread: 60,
    scalar: 2.0,
    startVelocity: 120,
    particleCount: 180,
    drift: 0.5,
    shapes,
    origin: { x: 0, y: 1.1 },
  });
  return fire({
    angle: 120,
    spread: 60,
    scalar: 2.0,
    startVelocity: 110,
    particleCount: 180,
    drift: -0.5,
    shapes,
    origin: { x: 1, y: 1.1 },
  });
}
